import React from "react";

function Nationalvision() {
  return (
    <>
      <div className=" py-5">
        <div className="container">
          <div className="row justify-content-center pb-3 pt-lg-3 py-lg-5">
            <div
              data-aos="fade-right"
              data-aos-duration="800"
              data-aos-delay="200"
              className="col-12 col-md-9 pt-5 pt-lg-0"
            >
              <h2 className="text-center ff_josfin color-light-black font-2xl text-uppercase px-lg-3 mt-xl-5">
                cyboryx aims to be an accelerator for{" "}
                <span className="color-dark-blue d-xxl-block">
                  qatar national vision 2030
                </span>
              </h2>
            </div>
          </div>
          <div className="row  justify-content-between pt-lg-5 mt-lg-3">
            <div data-aos="fade-right" className="col-12 col-lg-5">
              <p className="font-md font-normal text-uppercase pe-xl-4 text-center text-lg-start">
                cyboryx is an accelerator of qnv2030, that will embody the
                future of innovation in business, well being of society and
                sustainability.
              </p>
            </div>
            <div data-aos="fade-left" className="col-12 col-lg-5 ">
              <p className="font-md font-normal text-uppercase pe-xl-5 text-center text-lg-start">
                CYBORYX OFFERS MANY UNIQUE CYBERSECURITY DEVELOPMENT IN
                DIFFERENT SIZES ACROSS MULTIPLE INDUSTRIAL SECTORS{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Nationalvision;
